module.exports = __webpack_public_path__ + "static/media/unionPay.d5a6ffba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unionPay.svg
// module id = 2079
// module chunks = 0